import { BaseProperties } from "./base.interface";

export enum DayOfWeek {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}

export interface TimeInterval {
  startWork: string;
  endWork: string;
}

export interface OperatingDay {
  day: DayOfWeek;
  intervals: TimeInterval[];
}

export enum MenuPaymentMethodsMethod {
  PIX = "PIX",
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  ZELLE = "ZELLE",
}

export interface MenusInput {
  name: string;
  description: string;
  isVisible: boolean;
  acceptDelivery: boolean;
  minDeliveryTime: number;
  maxDeliveryTime: number;

  operatingDays: OperatingDay[];

  maxDistance: number;
  allowedPaymentMethods: MenuPaymentMethodsMethod[];

  minOrderPrice: number;
  minDeliveryPrice: number;
  maxDeliveryPrice: number;
  kmTax: number;
}

export interface MenusOutput extends BaseProperties, MenusInput {
  organizationId?: string;
  slug: string;
}
